import React from 'react';
import { css } from '@emotion/react';
import { AnimatePresence } from 'motion/react';
import { breakpoints } from '@frontend/responsiveness';
import { Button } from '@frontend/design-system';

interface DismissButtonProps {
  show: boolean;
  trackingId?: string;
  onDismiss?: () => void;
}

export const DismissButton: React.FC<DismissButtonProps> = ({ show, onDismiss, trackingId }) => {
  if (!show) return null;

  return (
    <AnimatePresence mode='popLayout'>
      <Button
        css={dismissButtonStyle}
        variant='secondary'
        iconName='x'
        onClick={onDismiss}
        aria-label='Dismiss'
        trackingId={trackingId}
        data-testid='global-banner-dismiss-btn'
      />
    </AnimatePresence>
  );
};

const dismissButtonStyle = css`
  @container (max-width: ${breakpoints.small.min}px) {
    position: absolute;
    top: 0;
    right: 0;
  }
`;
